import React, { useState } from "react";
import { AllCatserviceSection } from "../../FetchAPI";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import AllClaimLeadDatatable from "./AllClaimLeadDatatable";
import "./AllCatServiceWiseLeads.css";

export default function AllCliamTotalLead({ RendomTokenfetch, AllserviceCat }) {
  const [activeTab, setActiveTab] = useState("1");
  const [ActiveSerTab, setActiveSerTab] = useState("1");
  // const [ActiveLeads, setActiveLeads] = useState("1");

  const handleCatID = (e, catId) => {
    setActiveTab(catId); // Update active tab ID
  };
  const handleSerID = (e, serID) => {
    setActiveSerTab(serID); // Update active tab ID
  };

  const [serviceData, SerCat, loading] = AllCatserviceSection(
    RendomTokenfetch,
    activeTab,
    "5",
    "0"
  );
  // const [VendorLeads, loadingsd] = AllClaimLeads(
  //   RendomTokenfetch,
  //   activeTab,
  //   ActiveSerTab
  // );

  // console.log(ActiveSerTab);
  // console.log(ActiveLeads);
  // console.log(VendorLeads);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <div className="container mt-2 tOTALlEADbOX">
        <ul className="nav nav-tabs" role="tablist">
          {AllserviceCat.length > 0 ? (
            AllserviceCat.map((catData, index) => (
              <li key={index} className="nav-item">
                <a
                  className={`nav-link leadCat ${
                    catData.id === activeTab ? "active" : ""
                  }`}
                  data-bs-toggle="tab"
                  href={`#cat${catData.id}`}
                  onClick={(e) => handleCatID(e, catData.id)}
                >
                  {catData.category}
                </a>
              </li>
            ))
          ) : (
            <div className="noCommnetLead text-center py-3 fw-100">
              No Found!
            </div>
          )}
        </ul>

        {serviceData.length > 0 ? (
          <div className="tab-content">
            <div
              id={`cat${activeTab}`}
              className={`ServiceTabsBox  tab-pane ${
                activeTab === SerCat.catid ? "active" : "fade"
              }`}
            >
              <div className="content CatServicetabs">
                <ul className="nav nav-tabs" role="tablist">
                  {serviceData.length > 0
                    ? serviceData.map((serviceData, index) => (
                        <li key={index} className="nav-item">
                          <a
                            className={`nav-link leadservice ${
                              serviceData.id === ActiveSerTab ? "active" : ""
                            }`}
                            data-bs-toggle="tab"
                            href={`#ser${serviceData.id}`}
                            onClick={(e) => handleSerID(e, serviceData.id)}
                          >
                            {serviceData.title}
                          </a>
                        </li>
                      ))
                    : ""}
                </ul>
              </div>

              <div className="tab-content leaddataBox LeadDatatable">
                <AllClaimLeadDatatable
                  RendomTokenfetch={RendomTokenfetch}
                  catid={activeTab}
                  serid={ActiveSerTab}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="noCommnetLead text-center py-3 fw-100">
            No Services!
          </div>
        )}
      </div>
    </>
  );
}
